export default __webpack_public_path__ + "static/media/ic_notification.8dee562d.svg";